// import React from "react";
// import { useNavigate } from "react-router-dom";
// export default function WelcomeGateway({ onSelectRole }) {
//   // onSelectRole ek function prop hai jo aapke router ya parent handler ko trigger karega
//   // Example usage: <WelcomeGateway onSelectRole={(role) => myRouteHandler(role)} />
//  const navigate = useNavigate();

//   return (
//     <div className="bazaar-gate-container">
//       {/* SCOPED STANDALONE PRODUCTION DESIGN ENGINE */}
//       <style>{`
//         .bazaar-gate-container {
//           min-height: 100vh;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
//           font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
//           padding: 20px;
//           box-sizing: border-box;
//         }
//         .gateway-card {
//           background: #ffffff;
//           width: 100%;
//           max-width: 480px;
//           border-radius: 28px;
//           border: 1px solid rgba(255, 255, 255, 0.7);
//           box-shadow: 0 30px 60px -15px rgba(15, 23, 42, 0.06), 
//                       0 10px 20px -5px rgba(15, 23, 42, 0.04);
//           padding: 44px 36px;
//           box-sizing: border-box;
//           position: relative;
//           overflow: hidden;
//         }
//         .gateway-card::before {
//           content: '';
//           position: absolute;
//           top: 0; left: 0; right: 0;
//           height: 6px;
//           background: linear-gradient(90deg, #3b82f6 0%, #1d4ed8 100%);
//         }
//         .brand-header {
//           text-align: center;
//           margin-bottom: 40px;
//         }
//         .brand-badge {
//           display: inline-block;
//           padding: 6px 14px;
//           background: #eff6ff;
//           color: #2563eb;
//           font-size: 12px;
//           font-weight: 700;
//           text-transform: uppercase;
//           letter-spacing: 1px;
//           border-radius: 100px;
//           margin-bottom: 16px;
//         }
//         .main-title {
//           font-size: 32px;
//           font-weight: 800;
//           color: #0f172a;
//           margin: 0 0 10px 0;
//           letter-spacing: -0.03em;
//         }
//         .sub-title {
//           font-size: 15px;
//           color: #64748b;
//           margin: 0;
//           line-height: 1.5;
//         }
//         .selection-zone {
//           display: flex;
//           flex-direction: column;
//           gap: 18px;
//         }
//         .role-action-card {
//           width: 100%;
//           background: #ffffff;
//           border: 2px solid #e2e8f0;
//           border-radius: 20px;
//           padding: 24px;
//           text-align: left;
//           cursor: pointer;
//           transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           box-sizing: border-box;
//         }
//         .role-action-card:hover {
//           border-color: #2563eb;
//           background: #fafafa;
//           transform: translateY(-2px);
//           box-shadow: 0 12px 20px -8px rgba(37, 99, 235, 0.15);
//         }
//         .meta-details {
//           flex: 1;
//           padding-right: 16px;
//         }
//         .role-heading {
//           margin: 0 0 6px 0;
//           font-size: 18px;
//           font-weight: 700;
//           color: #0f172a;
//           display: flex;
//           align-items: center;
//           gap: 8px;
//         }
//         .role-heading .icon-tag {
//           font-size: 20px;
//         }
//         .role-desc {
//           margin: 0;
//           font-size: 13.5px;
//           color: #64748b;
//           line-height: 1.5;
//         }
//         .action-arrow {
//           width: 36px;
//           height: 36px;
//           border-radius: 50%;
//           background: #f1f5f9;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           color: #475569;
//           font-weight: 700;
//           font-size: 14px;
//           transition: all 0.2s ease;
//         }
//         .role-action-card:hover .action-arrow {
//           background: #2563eb;
//           color: #ffffff;
//           transform: translateX(4px);
//         }
//         .footer-note {
//           text-align: center;
//           margin-top: 36px;
//           font-size: 13px;
//           color: #94a3b8;
//         }
//       `}</style>

//       <div className="gateway-card">
//         {/* BRAND IDENTITY BLOCK */}
//         <div className="brand-header">
//           <div className="brand-badge">Unified Platform</div>
//           <h1 className="main-title">Count My Visit</h1>
//           <p className="sub-title">
//             Please choose how you want to proceed into your workspace environment today.
//           </p>
//         </div>

//         {/* INTERACTIVE NAVIGATION CARDS */}
//         <div className="selection-zone">
          
//           {/* OPTION A: MERCHANT PORTAL GATE */}
//           <div 
//             className="role-action-card" 
          
//             onClick={() => navigate("/MerchantAuth")}
//           >
//             <div className="meta-details">
//               <h3 className="role-heading">
//                 <span className="icon-tag">🏬</span> Merchant Account
//               </h3>
//               <p className="role-desc">
//                 Access your store hub, monitor walk-ins, manage business configurations, and view customer logs.
//               </p>
//             </div>
//             <div className="action-arrow">➔</div>
//           </div>

//           {/* OPTION B: CUSTOMER CONSUMER GATE */}
//           <div 
//             className="role-action-card" 
//             onClick={() => navigate("/Login")}
//           >
//             <div className="meta-details">
//               <h3 className="role-heading">
//                 <span className="icon-tag">👤</span> Customer Login
//               </h3>
//               <p className="role-desc">
//                 Explore premium nearby retail vendors, claim check-in rewards, and manage your public user profile.
//               </p>
//             </div>
//             <div className="action-arrow">➔</div>
//           </div>

//         </div>

//         {/* COMPLIANCE FOOTER META */}
//         <div className="footer-note">
//           Secured Enterprise Onboarding Gateway • Hub v2.0
//         </div>
//       </div>
//     </div>
//   );
// }



// import React from "react";
// import { useNavigate } from "react-router-dom";

// export default function WelcomeGateway() {
//   const navigate = useNavigate();

//   return (
//     <div style={styles.bazaarGateContainer}>
//       <div style={styles.gatewayCard}>
        
//         {/* BRAND IDENTITY BLOCK */}
//         <div style={styles.brandHeader}>
//           <div style={styles.brandBadge}>Unified Platform</div>
//           <h1 style={styles.mainTitle}>Count My Visit</h1>
//           <p style={styles.subTitle}>
//             Please choose how you want to proceed into your workspace environment today.
//           </p>
//         </div>

//         {/* INTERACTIVE NAVIGATION CARDS */}
//         <div style={styles.selectionZone}>
          
//           {/* OPTION A: MERCHANT PORTAL GATE */}
//           <div 
//             style={styles.roleActionCard} 
//             onClick={() => navigate("/MerchantAuth")}
//             onMouseEnter={(e) => {
//               e.currentTarget.style.borderColor = "#ff5e62";
//               e.currentTarget.style.transform = "translateY(-2px)";
//               e.currentTarget.style.boxShadow = "0 12px 20px -8px rgba(255, 94, 98, 0.25)";
//             }}
//             onMouseLeave={(e) => {
//               e.currentTarget.style.borderColor = "#e2e8f0";
//               e.currentTarget.style.transform = "translateY(0)";
//               e.currentTarget.style.boxShadow = "none";
//             }}
//           >
//             <div style={styles.metaDetails}>
//               <h3 style={styles.roleHeading}>
//                 <span style={styles.iconTag}>🏬</span> Merchant Account
//               </h3>
//               <p style={styles.roleDesc}>
//                 Access your store hub, monitor walk-ins, manage business configurations, and view customer logs.
//               </p>
//             </div>
//             <div style={styles.actionArrow}>➔</div>
//           </div>

//           {/* OPTION B: CUSTOMER CONSUMER GATE */}
//           <div 
//             style={styles.roleActionCard} 
//             onClick={() => navigate("/Login")}
//             onMouseEnter={(e) => {
//               e.currentTarget.style.borderColor = "#ff5e62";
//               e.currentTarget.style.transform = "translateY(-2px)";
//               e.currentTarget.style.boxShadow = "0 12px 20px -8px rgba(255, 94, 98, 0.25)";
//             }}
//             onMouseLeave={(e) => {
//               e.currentTarget.style.borderColor = "#e2e8f0";
//               e.currentTarget.style.transform = "translateY(0)";
//               e.currentTarget.style.boxShadow = "none";
//             }}
//           >
//             <div style={styles.metaDetails}>
//               <h3 style={styles.roleHeading}>
//                 <span style={styles.iconTag}>👤</span> Customer Login
//               </h3>
//               <p style={styles.roleDesc}>
//                 Explore premium nearby retail vendors, claim check-in rewards, and manage your public user profile.
//               </p>
//             </div>
//             <div style={styles.actionArrow}>➔</div>
//           </div>

//         </div>

//         {/* COMPLIANCE FOOTER META */}
//         <div style={styles.footerNote}>
//           Secured Enterprise Onboarding Gateway • Hub v2.0
//         </div>
//       </div>
//     </div>
//   );
// }

// // FIXED JAVASCRIPT OBJECT STYLESHEET
// const styles = {
//   bazaarGateContainer: {
//     minHeight: "100vh",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     background: "linear-gradient(135deg, #ff8c42, #ff5e62)",
//     fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
//     padding: "20px",
//     boxSizing: "border-box",
//   },
//   gatewayCard: {
//     background: "#ffffff",
//     width: "100%",
//     maxWidth: "480px",
//     borderRadius: "28px",
//     border: "1px solid rgba(255, 255, 255, 0.7)",
//     boxShadow: "0 30px 60px -15px rgba(15, 23, 42, 0.15), 0 10px 20px -5px rgba(15, 23, 42, 0.1)",
//     padding: "44px 36px",
//     boxSizing: "border-box",
//     position: "relative",
//     overflow: "hidden",
//   },
//   brandHeader: {
//     textAlign: "center",
//     marginBottom: "40px",
//   },
//   brandBadge: {
//     display: "inline-block",
//     padding: "6px 14px",
//     background: "#fff0ea",
//     color: "#ff5e62",
//     fontSize: "12px",
//     fontWeight: "700",
//     textTransform: "uppercase",
//     letterSpacing: "1px",
//     borderRadius: "100px",
//     marginBottom: "16px",
//   },
//   mainTitle: {
//     fontSize: "32px",
//     fontWeight: "800",
//     color: "#0f172a",
//     margin: "0 0 10px 0",
//     letterSpacing: "-0.03em",
//   },
//   subTitle: {
//     fontSize: "15px",
//     color: "#64748b",
//     margin: "0",
//     lineHeight: "1.5",
//   },
//   selectionZone: {
//     display: "flex",
//     flexDirection: "column",
//     gap: "18px",
//   },
//   roleActionCard: {
//     width: "100%",
//     background: "#ffffff",
//     border: "2px solid #e2e8f0",
//     borderRadius: "20px",
//     padding: "24px",
//     textAlign: "left",
//     cursor: "pointer",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     boxSizing: "border-box",
//     transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
//   },
//   metaDetails: {
//     flex: "1",
//     paddingRight: "16px",
//   },
//   roleHeading: {
//     margin: "0 0 6px 0",
//     fontSize: "18px",
//     fontWeight: "700",
//     color: "#0f172a",
//     display: "flex",
//     alignItems: "center",
//     gap: "8px",
//   },
//   iconTag: {
//     fontSize: "20px",
//   },
//   roleDesc: {
//     margin: "0",
//     fontSize: "13.5px",
//     color: "#64748b",
//     lineHeight: "1.5",
//   },
//   actionArrow: {
//     width: "36px",
//     height: "36px",
//     borderRadius: "50%",
//     background: "#f1f5f9",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     color: "#475569",
//     fontWeight: "700",
//     fontSize: "14px",
//     transition: "all 0.2s ease",
//   },
//   footerNote: {
//     textAlign: "center",
//     marginTop: "36px",
//     fontSize: "13px",
//     color: "#94a3b8",
//   },
// };





// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";

// export default function WelcomeGateway() {
//   const navigate = useNavigate();
//   const [hoveredCard, setHoveredCard] = useState(null);

//   return (
//     <div style={styles.page}>
//       <div style={styles.container}>
//         {/* Brand Header */}
//         <div style={styles.brand}>
//           <div style={styles.logoWrapper}>
//             <div style={styles.logo}>
//               <span style={styles.logoText}>CMV</span>
//             </div>
//           </div>

//           <div style={styles.badge}>Welcome Back</div>
//           <h1 style={styles.title}>Count My Visit</h1>
//           <p style={styles.subtitle}>Choose an option below to access your account</p>
//         </div>
 
//         {/* Login Cards */}
//         <div style={styles.cards}>
//           {/* Merchant Account */}
//           <button
//             type="button"
//             style={{
//               ...styles.card,
//               ...(hoveredCard === "merchant" ? styles.merchantHover : {}),
//             }}
//             onClick={() => navigate("/MerchantAuth")}
//             onMouseEnter={() => setHoveredCard("merchant")}
//             onMouseLeave={() => setHoveredCard(null)}
//           >
//             <div style={{ ...styles.iconWrapper, ...styles.merchantIconWrapper }}>
//               🏪
//             </div>

//             <div style={styles.cardContent}>
//               <h2 style={styles.cardTitle}>Merchant Account</h2>
//               <p style={styles.cardText}>Manage business visits & analytics</p>
//             </div>

//             <div
//               style={{
//                 ...styles.arrowCircle,
//                 ...(hoveredCard === "merchant" ? styles.merchantArrowHover : {}),
//               }}
//             >
//               →
//             </div>
//           </button>

//           {/* Customer Account */}
//           <button
//             type="button"
//             style={{
//               ...styles.card,
//               ...(hoveredCard === "customer" ? styles.customerHover : {}),
//             }}
//             onClick={() => navigate("/Login")}
//             onMouseEnter={() => setHoveredCard("customer")}
//             onMouseLeave={() => setHoveredCard(null)}
//           >
//             <div style={{ ...styles.iconWrapper, ...styles.customerIconWrapper }}>
//               👤
//             </div>

//             <div style={styles.cardContent}>
//               <h2 style={styles.cardTitle}>Customer Login</h2>
//               <p style={styles.cardText}>Track your reward points & history</p>
//             </div>

//             <div
//               style={{
//                 ...styles.arrowCircle,
//                 ...(hoveredCard === "customer" ? styles.customerArrowHover : {}),
//               }}
//             >
//               →
//             </div>
//           </button>
//         </div>

//         {/* Footer Support Link */}
//         <p style={styles.footerText}>
//           Need help? <a href="#support" style={styles.link}>Contact Support</a>
//         </p>
//       </div>
//     </div>
//   );
// }

// const styles = {
//   page: {
//     minHeight: "100vh",
//     width: "100%",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     padding: "24px",
//     boxSizing: "border-box",
//     background: "linear-gradient(135deg, #FFF6F3 0%, #FFFFFF 50%, #FFF0EB 100%)",
//     fontFamily:
//       'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
//   },

//   container: {
//     width: "100%",
//     maxWidth: "460px",
//     padding: "40px 32px",
//     boxSizing: "border-box",
//     borderRadius: "28px",
//     backgroundColor: "#FFFFFF",
//     border: "1px solid rgba(255, 94, 98, 0.12)",
//     boxShadow: "0 20px 40px -15px rgba(255, 94, 98, 0.08), 0 10px 20px -10px rgba(17, 24, 39, 0.04)",
//   },

//   brand: {
//     textAlign: "center",
//     marginBottom: "32px",
//   },

//   logoWrapper: {
//     display: "inline-block",
//     padding: "8px",
//     borderRadius: "26px",
//     background: "rgba(255, 140, 66, 0.1)",
//     marginBottom: "16px",
//   },

//   logo: {
//     width: "68px",
//     height: "68px",
//     borderRadius: "20px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     background: "linear-gradient(135deg, #FF8C42 0%, #FF5E62 100%)",
//     boxShadow: "0 12px 25px rgba(255, 94, 98, 0.35)",
//   },

//   logoText: {
//     color: "#FFFFFF",
//     fontSize: "20px",
//     fontWeight: "900",
//     letterSpacing: "1px",
//   },

//   badge: {
//     display: "inline-block",
//     padding: "4px 12px",
//     borderRadius: "20px",
//     backgroundColor: "rgba(255, 94, 98, 0.08)",
//     color: "#FF5E62",
//     fontSize: "12px",
//     fontWeight: "700",
//     letterSpacing: "0.5px",
//     marginBottom: "10px",
//     textTransform: "uppercase",
//   },

//   title: {
//     margin: 0,
//     fontSize: "28px",
//     fontWeight: "800",
//     color: "#1E293B",
//     letterSpacing: "-0.5px",
//   },

//   subtitle: {
//     margin: "8px 0 0",
//     fontSize: "14px",
//     color: "#64748B",
//     fontWeight: "400",
//   },

//   cards: {
//     display: "flex",
//     flexDirection: "column",
//     gap: "16px",
//   },

//   card: {
//     width: "100%",
//     border: "2px solid #F1F5F9",
//     borderRadius: "20px",
//     backgroundColor: "#FFFFFF",
//     padding: "18px 20px",
//     display: "flex",
//     alignItems: "center",
//     gap: "16px",
//     textAlign: "left",
//     cursor: "pointer",
//     outline: "none",
//     transition: "all 0.25s cubic-bezier(0.16, 1, 0.3, 1)",
//     boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.02)",
//   },

//   merchantHover: {
//     transform: "translateY(-3px)",
//     borderColor: "#FF5E62",
//     boxShadow: "0 15px 30px -10px rgba(255, 94, 98, 0.2)",
//   },

//   customerHover: {
//     transform: "translateY(-3px)",
//     borderColor: "#6366F1",
//     boxShadow: "0 15px 30px -10px rgba(99, 102, 241, 0.2)",
//   },

//   iconWrapper: {
//     width: "52px",
//     height: "52px",
//     minWidth: "52px",
//     borderRadius: "16px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     fontSize: "24px",
//   },

//   merchantIconWrapper: {
//     background: "linear-gradient(135deg, #FFF0EC 0%, #FFE4DD 100%)",
//   },

//   customerIconWrapper: {
//     background: "linear-gradient(135deg, #EEF2FF 0%, #E0E7FF 100%)",
//   },

//   cardContent: {
//     flex: 1,
//     minWidth: 0,
//   },

//   cardTitle: {
//     margin: 0,
//     color: "#0F172A",
//     fontSize: "16px",
//     fontWeight: "700",
//   },

//   cardText: {
//     margin: "3px 0 0",
//     color: "#64748B",
//     fontSize: "13px",
//   },

//   arrowCircle: {
//     width: "36px",
//     height: "36px",
//     minWidth: "36px",
//     borderRadius: "50%",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     backgroundColor: "#F8FAFC",
//     color: "#94A3B8",
//     fontSize: "16px",
//     fontWeight: "bold",
//     transition: "all 0.25s ease",
//   },

//   merchantArrowHover: {
//     backgroundColor: "#FF5E62",
//     color: "#FFFFFF",
//     transform: "translateX(4px)",
//     boxShadow: "0 4px 12px rgba(255, 94, 98, 0.4)",
//   },

//   customerArrowHover: {
//     backgroundColor: "#6366F1",
//     color: "#FFFFFF",
//     transform: "translateX(4px)",
//     boxShadow: "0 4px 12px rgba(99, 102, 241, 0.4)",
//   },

//   footerText: {
//     marginTop: "28px",
//     textAlign: "center",
//     fontSize: "13px",
//     color: "#94A3B8",
//   },

//   link: {
//     color: "#FF5E62",
//     textDecoration: "none",
//     fontWeight: "600",
//   },
// };

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function WelcomeGateway() {
  const navigate = useNavigate();
  const [hoveredCard, setHoveredCard] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // Form State matching your database fields
  const [formData, setFormData] = useState({
    user_id: "",
    username: "",
    password: "",
    business_name: "",
    business_type: "",
    gst_number: "",
    owner_name: "",
    mobile: "",
    otp: "",
    address: "",
    status: "active",
    subscription: "free",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // WhatsApp Send Handler
  const handleSubmit = (e) => {
    e.preventDefault();

    const targetMobile = "919779306376"; // Target WhatsApp Number

    const message = `*New Shopkeeper Registration Request*%0A%0A` +
       
      `*Owner Name:* ${formData.owner_name}%0A` +
      `*Business Name:* ${formData.business_name}%0A` +
      `*Business Type:* ${formData.business_type}%0A` +
      `*Mobile:* ${formData.mobile}%0A` +
      `*GST Number:* ${formData.gst_number || "N/A"}%0A` +
      `*Address:* ${formData.address}%0A`;
      
  

    const whatsappUrl = `https://wa.me/${targetMobile}?text=${message}`;
    window.open(whatsappUrl, "_blank");

    setShowModal(false);
  };

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        {/* Brand Header */}
        <div style={styles.brand}>
          <div style={styles.logoWrapper}>
            <div style={styles.logo}>
              <span style={styles.logoText}>CMV</span>
            </div>
          </div>

          <div style={styles.badge}>Welcome Back</div>
          <h1 style={styles.title}>Count My Visit</h1>
          <p style={styles.subtitle}>Choose an option below to access your account</p>
        </div>

        {/* Login & Action Cards */}
        <div style={styles.cards}>
          {/* Merchant Account */}
          <button
            type="button"
            style={{
              ...styles.card,
              ...(hoveredCard === "merchant" ? styles.merchantHover : {}),
            }}
           
            onClick={() => navigate("/MerchantAuth", { replace: true })}
            onMouseEnter={() => setHoveredCard("merchant")}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <div style={{ ...styles.iconWrapper, ...styles.merchantIconWrapper }}>
              🏪
            </div>

            <div style={styles.cardContent}>
              <h2 style={styles.cardTitle}>Merchant Account</h2>
              <p style={styles.cardText}>Manage business visits & analytics</p>
            </div>

            <div
              style={{
                ...styles.arrowCircle,
                ...(hoveredCard === "merchant" ? styles.merchantArrowHover : {}),
              }}
            >
              →
            </div>
          </button>

          {/* Customer Account */}
          <button
            type="button"
            style={{
              ...styles.card,
              ...(hoveredCard === "customer" ? styles.customerHover : {}),
            }}
            onClick={() => navigate("/Login", { replace: true })}
            onMouseEnter={() => setHoveredCard("customer")}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <div style={{ ...styles.iconWrapper, ...styles.customerIconWrapper }}>
              👤
            </div>

            <div style={styles.cardContent}>
              <h2 style={styles.cardTitle}>Customer Login</h2>
              <p style={styles.cardText}>Track your reward points & history</p>
            </div>

            <div
              style={{
                ...styles.arrowCircle,
                ...(hoveredCard === "customer" ? styles.customerArrowHover : {}),
              }}
            >
              →
            </div>
          </button>

          {/* NEW: Create Shopkeeper / Register */}
          <button
            type="button"
            style={{
              ...styles.card,
              ...(hoveredCard === "shopkeeper" ? styles.shopkeeperHover : {}),
            }}
            onClick={() => setShowModal(true)}
            onMouseEnter={() => setHoveredCard("shopkeeper")}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <div style={{ ...styles.iconWrapper, ...styles.shopkeeperIconWrapper }}>
              ➕
            </div>

            <div style={styles.cardContent}>
              <h2 style={styles.cardTitle}>Create Merchant Account </h2>
              {/* <p style={styles.cardText}>create   account</p> */}
            </div>

            <div
              style={{
                ...styles.arrowCircle,
                ...(hoveredCard === "shopkeeper" ? styles.shopkeeperArrowHover : {}),
              }}
            >
              →
            </div>
          </button>
        </div>

        {/* Footer Support Link */}
        <p style={styles.footerText}>
          Need help? <a href="#support" style={styles.link}>Contact Support</a>
        </p>
      </div>

      {/* Registration Modal Form */}
      {showModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <div style={styles.modalHeader}>
              <h2 style={{ margin: 0, fontSize: "20px", color: "#1E293B" }}> Add Merchant details</h2>
              <button onClick={() => setShowModal(false)} style={styles.closeBtn}>✕</button>
            </div>

            <form onSubmit={handleSubmit} style={styles.formGrid}>
                
              <input type="text" name="owner_name" placeholder="Owner Name" required onChange={handleChange} style={styles.input} />
              <input type="text" name="business_name" placeholder="Business Name" required onChange={handleChange} style={styles.input} />
              <input type="text" name="business_type" placeholder="Business Type" required onChange={handleChange} style={styles.input} />
              <input type="text" name="mobile" placeholder="Mobile Number" required onChange={handleChange} style={styles.input} />
              <input type="text" name="gst_number" placeholder="GST Number (Optional)" onChange={handleChange} style={styles.input} />
              <textarea name="address" placeholder="Full Address" required onChange={handleChange} style={{ ...styles.input, gridColumn: "span 2", height: "60px" }} />
              
              
   
              <button type="submit" style={styles.submitBtn}>
                Submit & Send to WhatsApp 💬
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
    boxSizing: "border-box",
    background: "linear-gradient(135deg, #FFF6F3 0%, #FFFFFF 50%, #FFF0EB 100%)",
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },

  container: {
    width: "100%",
    maxWidth: "460px",
    padding: "40px 32px",
    boxSizing: "border-box",
    borderRadius: "28px",
    backgroundColor: "#FFFFFF",
    border: "1px solid rgba(255, 94, 98, 0.12)",
    boxShadow: "0 20px 40px -15px rgba(255, 94, 98, 0.08), 0 10px 20px -10px rgba(17, 24, 39, 0.04)",
  },

  brand: {
    textAlign: "center",
    marginBottom: "32px",
  },

  logoWrapper: {
    display: "inline-block",
    padding: "8px",
    borderRadius: "26px",
    background: "rgba(255, 140, 66, 0.1)",
    marginBottom: "16px",
  },

  logo: {
    width: "68px",
    height: "68px",
    borderRadius: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #FF8C42 0%, #FF5E62 100%)",
    boxShadow: "0 12px 25px rgba(255, 94, 98, 0.35)",
  },

  logoText: {
    color: "#FFFFFF",
    fontSize: "20px",
    fontWeight: "900",
    letterSpacing: "1px",
  },

  badge: {
    display: "inline-block",
    padding: "4px 12px",
    borderRadius: "20px",
    backgroundColor: "rgba(255, 94, 98, 0.08)",
    color: "#FF5E62",
    fontSize: "12px",
    fontWeight: "700",
    letterSpacing: "0.5px",
    marginBottom: "10px",
    textTransform: "uppercase",
  },

  title: {
    margin: 0,
    fontSize: "28px",
    fontWeight: "800",
    color: "#1E293B",
    letterSpacing: "-0.5px",
  },

  subtitle: {
    margin: "8px 0 0",
    fontSize: "14px",
    color: "#64748B",
    fontWeight: "400",
  },

  cards: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },

  card: {
    width: "100%",
    border: "2px solid #F1F5F9",
    borderRadius: "20px",
    backgroundColor: "#FFFFFF",
    padding: "18px 20px",
    display: "flex",
    alignItems: "center",
    gap: "16px",
    textAlign: "left",
    cursor: "pointer",
    outline: "none",
    transition: "all 0.25s cubic-bezier(0.16, 1, 0.3, 1)",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.02)",
  },

  merchantHover: {
    transform: "translateY(-3px)",
    borderColor: "#FF5E62",
    boxShadow: "0 15px 30px -10px rgba(255, 94, 98, 0.2)",
  },

  customerHover: {
    transform: "translateY(-3px)",
    borderColor: "#6366F1",
    boxShadow: "0 15px 30px -10px rgba(99, 102, 241, 0.2)",
  },

  shopkeeperHover: {
    transform: "translateY(-3px)",
    borderColor: "#10B981",
    boxShadow: "0 15px 30px -10px rgba(16, 185, 129, 0.2)",
  },

  iconWrapper: {
    width: "52px",
    height: "52px",
    minWidth: "52px",
    borderRadius: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "24px",
  },

  merchantIconWrapper: {
    background: "linear-gradient(135deg, #FFF0EC 0%, #FFE4DD 100%)",
  },

  customerIconWrapper: {
    background: "linear-gradient(135deg, #EEF2FF 0%, #E0E7FF 100%)",
  },

  shopkeeperIconWrapper: {
    background: "linear-gradient(135deg, #E6F4EA 0%, #C3E6CB 100%)",
  },

  cardContent: {
    flex: 1,
    minWidth: 0,
  },

  cardTitle: {
    margin: 0,
    color: "#0F172A",
    fontSize: "16px",
    fontWeight: "700",
  },

  cardText: {
    margin: "3px 0 0",
    color: "#64748B",
    fontSize: "13px",
  },

  arrowCircle: {
    width: "36px",
    height: "36px",
    minWidth: "36px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#F8FAFC",
    color: "#94A3B8",
    fontSize: "16px",
    fontWeight: "bold",
    transition: "all 0.25s ease",
  },

  merchantArrowHover: {
    backgroundColor: "#FF5E62",
    color: "#FFFFFF",
    transform: "translateX(4px)",
    boxShadow: "0 4px 12px rgba(255, 94, 98, 0.4)",
  },

  customerArrowHover: {
    backgroundColor: "#6366F1",
    color: "#FFFFFF",
    transform: "translateX(4px)",
    boxShadow: "0 4px 12px rgba(99, 102, 241, 0.4)",
  },

  shopkeeperArrowHover: {
    backgroundColor: "#10B981",
    color: "#FFFFFF",
    transform: "translateX(4px)",
    boxShadow: "0 4px 12px rgba(16, 185, 129, 0.4)",
  },

  footerText: {
    marginTop: "28px",
    textAlign: "center",
    fontSize: "13px",
    color: "#94A3B8",
  },

  link: {
    color: "#FF5E62",
    textDecoration: "none",
    fontWeight: "600",
  },

  /* Modal Styling */
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(15, 23, 42, 0.5)",
    backdropFilter: "blur(4px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    padding: "16px",
  },

  modalContent: {
    backgroundColor: "#FFFFFF",
    borderRadius: "20px",
    padding: "24px",
    width: "100%",
    maxWidth: "500px",
    boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1)",
  },

  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },

  closeBtn: {
    border: "none",
    background: "none",
    fontSize: "18px",
    cursor: "pointer",
    color: "#64748B",
  },

  formGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "12px",
  },

  input: {
    width: "100%",
    padding: "10px 12px",
    borderRadius: "8px",
    border: "1px solid #CBD5E1",
    fontSize: "13px",
    boxSizing: "border-box",
    outline: "none",
  },

  submitBtn: {
    gridColumn: "span 2",
    backgroundColor: "#25D366",
    color: "#FFFFFF",
    padding: "12px",
    borderRadius: "10px",
    border: "none",
    fontSize: "15px",
    fontWeight: "600",
    cursor: "pointer",
    marginTop: "8px",
    transition: "background 0.2s ease",
  },
};